import { ComponentProps } from "react"
import { twMerge } from "tailwind-merge"
import { tv } from "tailwind-variants"
import { Button } from "./Button"

type Props = ComponentProps<"div"> & {
  submitLabel?: string
  submitting?: boolean
  leftAligned?: boolean
}

const createStyles = tv({
  slots: {
    base: "pb-4 pt-5",
    group: "flex flex-col gap-2 @sm:flex-row @sm:justify-between",
  },
  variants: {
    leftAligned: {
      true: {
        group: "!justify-start",
      },
    },
  },
})

export function SubmitBar({ submitLabel, submitting, onClick, children, leftAligned, ...props }: Props) {
  const styles = createStyles({ leftAligned: leftAligned })

  return (
    <div className={twMerge("@container", props.className)} data-transition="children/fade">
      <div {...props} className={twMerge(styles.base(), styles.group(), !children && "@md:justify-end")}>
        {!!children && <div className={styles.group()}>{children}</div>}
        <Button type="submit" loading={submitting} onClick={onClick}>
          {submitLabel ?? "Submit"}
        </Button>
      </div>
    </div>
  )
}
